import legendaryGroupsJson from '../jsons/legendarygroups.json'
import { legendaryDescDefault } from '../replacements.js'

const legendaryGroups = legendaryGroupsJson.legendaryGroup;

const COLOR_RED = "#D44E3B"
const COLOR_GREEN = "#68AA33"

const alignmentConst = {
    'L' : 'Lawful',
    'C' : 'Chaotic',
    'G' : 'Good',
    'E' : 'Evil',
    'N' : 'Neutral',
    'U' : 'Unaligned',
    'A' : 'Any Alignment'
}

const allyConst = {
    'G' : 'ally',
    'E' : 'enemy',
    'A' : 'enemy',
    'N' : 'neutral',
    'U' : 'neutral'
}

const colors = {
    "enemy": COLOR_RED,
    "neutral": '#999999',
    "ally": COLOR_GREEN,
    "pet": COLOR_GREEN
}

const sizeConst = {
    'T': 'Tiny',
    'S': 'Small',
    'M': 'Medium',
    'L': 'Large',
    'H': 'Huge',
    'G': 'Gargantuan',
}

const calcSize = (sizeArray) => {

    if(sizeArray) {
        let size = sizeArray.map((s) => sizeConst[s]).join(", ")
        return size
    }
        
    return "NO SIZE"
}

const calcAlignment = (alignmentArray) => {
    if(alignmentArray)
        return alignmentArray
            .map((a) => alignmentConst[a] || "") // Handle unmatched keys
            .join(" "); // Join matches into a single string
    return "--"
}

const calcSpeed = (speed) => {

    if(!speed) {
        return {'walk': 0}
    }

    if(speed && Object.entries(speed).forEach(([key, value]) => {
        if (typeof value === "object" && value !== null) {
            speed[key] = `${value.number} ${value.condition}`.trim();
        } else {
            speed[key] = value;
        }
    }))

    return speed;
}

const calcEntriesToSpecial = (entries) => {
    if(!entries)
        return undefined

    let abilities = []
    entries.map((e) => {
        abilities.push({
            name: '',
            entries: e,
            desc: e,
            rechargeCount: 0
        })
    })

    return abilities;
}

const calcActionTypes = (actionsArr) => {
    if(actionsArr) {
        actionsArr.forEach(action => {
            if(action.type === 'entries') {
                action.desc = " "
                action.entries.forEach(entry => {
                    if(typeof entry === 'string')
                        action.desc += entry + " "
                    else if(typeof entry === 'object') { // might not work
                        if(entry.entries)
                            actionsArr.push({name: entry.name, desc: " " + entry.entries.join(" ")})
                    }
                })
            } else if(action.type === 'actions') {
                action.desc = " "
                action.entries.forEach(entry => {
                    if(typeof entry === 'object') {
                        if(entry.attackEntries)
                            action.desc += entry.attackEntries.join(" ") + " "
                        if(entry.hitEntries)
                            action.desc += entry.hitEntries.join(" ") + " "
                    }
                })

            }
           
        });
    }

    return actionsArr;
}

// For immunities and resistances
const calcImmune = (defense, cKey) => {
    if (!defense) return "";

    const dString1 = defense
        .filter(entry => typeof entry === "string")
        .join(", ");

    let dString2 = defense
        .filter(entry => typeof entry === "object" && entry[cKey])
        .map(entry => `${entry[cKey].join(", ")} ${entry?.note}`)
        .join("; ");

    dString2 = dString2.replace('that is nonmagical', '(Non-Magical)')

    return `${dString1}${dString2 ? `${dString1 && ';' } ${dString2}` : ""}` 
};

const allyCheck = (alignmentArray) => {
    if(alignmentArray)
        alignmentArray.forEach(a => {
            if(a === "E" || a === "N" || a === "U" || a === "G") {
                return allyConst[a]
            }
        });
    return 'enemy'
}

function capsFirstLetter(word) {
    if (!word || word === '--')
        return '';

    return word.charAt(0).toUpperCase() + word.slice(1);
}

function mapSkills(skills) {
    if(skills) {
        let skillString = Object.entries(skills).map(([key, value]) => (
            capsFirstLetter(key) + value
        )).join(", ")
        return skillString
    }
    else 
        return ''
}

function calcSave(skill) {
    if(!skill && skill !== 0) return 0

    return Math.floor((skill-10)/2)
}

function addRechargeCount(objectsArr) {
    if(objectsArr) 
        return objectsArr.map(obj => {
            const match = obj.name.match(/\((\d+)\/[^)]+\)/); // Match (X/any text) pattern
            obj.rechargeCount = match ? parseInt(match[1]) * 10 : 0; // Set to null if no pattern is found
            return obj;
        });
    else 
        return null
}

const calcSenses = (senses, passive) => {
    let sensesString = ''
    if(senses) {
        sensesString = senses.join(", ")
    }

    if(passive)
        sensesString += `${sensesString ? ',' : ''} Passive Perception ${passive}`

    return sensesString
}

const calcCr = (object) => {

    let cr = object?.cr?.cr || object.cr
    // if(object?.cr?.lair)
    //     cr += "Lair: " + object?.cr?.lair
    return cr
}

const calcAC = (objectAc) => {
    if(typeof objectAc === 'number')
        return objectAc

    return 10;
}

const calcSpellCasting = (spellcasting) => {
    if(!spellcasting) {
        return []
    }

    return spellcasting.map((spellObj) => {
        let headerEntry = spellObj?.headerEntries?.join(" ");
        return {...spellObj, headerEntries: headerEntry}
    })

}

const findLairActions = (object) => {
    // find specific object with group name and source name
    let specificGroup = legendaryGroups.find(group => (group.name === object?.legendaryGroup?.name && group.source === object.source));
    
    // This creature is an abstraction of a parent group 
    if(specificGroup?._copy) {
        let templateGroup = {...legendaryGroups.find(group => (group.name === specificGroup?._copy?.name && group.source === specificGroup?._copy?.source))};
        
        if(templateGroup) {
            if(specificGroup._copy._mod.lairActions.mode === "prependArr") {
                templateGroup.lairActions = [...specificGroup._copy._mod.lairActions.items, ...templateGroup.lairActions]
            } else if(specificGroup._copy._mod.lairActions.mode === "appendArr") {
                templateGroup.lairActions = [...templateGroup.lairActions, ...specificGroup._copy._mod.lairActions.items]
            }

            return {
                lair_actions: templateGroup.lairActions || [],
                regional_effects: templateGroup.regionalEffects || []
            }
        }
    }

    let extraActions = {
        lair_actions: specificGroup?.lairActions || [],
        regional_effects: specificGroup?.regionalEffects || []
    }

    return extraActions
}

const sortHp = (object) => {
    if(typeof object.hp === 'number') {
        return {
            "hit_points_default": object.hp,
            "hit_points_special": undefined, // could be undefined
            "hit_points": object.hp,
            "hit_points_current": object.hp,
        }
    }

    if(object?.hp?.special) {
        return {
            "hit_points_default": 10,
            "hit_points_special": object.hp.special, // Full string special
            "hit_points": 10,
            "hit_points_current": 10,
        } 
    }
}

export const tools5eObjectToDmBMapper = (object, avatarUrl = null) => {
    let alignment = allyCheck(object.alignment)
    const armor_class = calcAC(object.ac) 
    const armor_desc = Array.isArray(object?.ac) && object?.ac[0]?.from ? ("(" + (object?.ac[0]?.from?.join("")) + ")") : "";
    const cr = calcCr(object)

    const str = object.str ?? 10;
    const dex = object.dex ?? 10;
    const con = object.con ?? 10;
    const int = object.int ?? 10;
    const cha = object.cha ?? 10;
    const wis = object.wis ?? 10;

    const hpValues = sortHp(object)

    let {lair_actions, regional_effects} = findLairActions(object);

    return {
        "name": object.name,
        "name_default": object.name,
        "from": "t5",
        "creatureGuid": null,
        "avatarUrl": avatarUrl,
        "speed": calcSpeed(object.speed),
        "armor_class": armor_class,
        "armor_desc": armor_desc,
        "creature_alignment": calcAlignment(object.alignment),
        "alignment": alignment,
        "groupGuid": null,
        "size": calcSize(object.size),
        "type": "monster",
        "border": colors[alignment],
        "creature_type": 'Siege Weapons',
        "subtype": capsFirstLetter(object.type?.tags?.join(",") || '--'),
        "hit_points_formula": object?.hp?.formula,
        ...hpValues, // hit_points_default, hit_points_special, hit_points, hit_points_current
        "hit_points_temp": 0,
        "hit_points_override": 0,
        "hit_points_modifier": 0,
        "initiative": 0,
        "effects": [],
        'damage_vulnerabilities': object?.vulnerable?.join(', ') || "",
        'damage_resistances': calcImmune(object?.resist, "resist") || "",
        'damage_immunities': calcImmune(object?.immune, "immune"),
        'condition_immunities': object?.conditionImmune?.join(', ') || "",
        "skills": mapSkills(object.skill),
        "senses": calcSenses(object?.senses, object?.passive),
        'languages': object?.languages?.join(', '),
        "cr": cr,
        "challenge_rating": cr,
        "special_abilities": calcEntriesToSpecial(object?.entries),
        "spellcasting": calcSpellCasting(object?.spellcasting),
        "actions": addRechargeCount(calcActionTypes(object?.actionEntries) || null),
        "bonus_actions": addRechargeCount(calcActionTypes(object?.bonus) || null),
        "reactions": addRechargeCount(calcActionTypes(object?.reaction) || null),
        "legendary_actions_count": object?.legendary?.length > 0 ? (object.legendaryActions ? object.legendaryActions * 10 : 30) : 0,
        "legendary_actions": addRechargeCount(calcActionTypes(object?.legendary) || null),
        "legendary_desc": object?.legendary?.length ? (object?.legendaryHeader?.join(" ") || legendaryDescDefault(object.name, object.legendaryActionsLair)) : "",
        "mythic_actions": addRechargeCount(calcActionTypes(object?.mythic) || null),
        "mythic_desc": object?.mythicHeader?.length ? (object?.mythicHeader?.join(" ") || "") : "",
        "lair_actions": lair_actions, 
        "regional_effects": regional_effects, 
        "inspiration": false,
        "bardic_inspiration": false,
        "hidden": true,
        "death_saves_failure_count": 0,
        "death_saves_success_count": 0,
        "inventory": [],
        "environments": '',
        "strength": str,
        "dexterity": dex,
        "constitution": con,
        "intelligence": int,
        "charisma": cha,
        "wisdom": wis,
        "strength_save": object.save?.str ?? calcSave(str),
        "dexterity_save":  object.save?.dex ?? calcSave(dex),
        "constitution_save":  object.save?.con ?? calcSave(con),
        "intelligence_save":  object.save?.int ?? calcSave(int),
        "charisma_save":  object.save?.cha ?? calcSave(cha),
        "wisdom_save":  object.save?.wis ?? calcSave(wis),
        "dnd_b_player_id": null,
        "sourceShort": object?.source,
        "page": object?.page,
    }
};

export default tools5eObjectToDmBMapper;